import React from 'react';

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import applyExportDataModule from 'highcharts/modules/export-data';
import applyExportingModule from 'highcharts/modules/exporting';
import applySeriesLabelModule from 'highcharts/modules/series-label';

applyExportingModule(Highcharts);
applyExportDataModule(Highcharts);
applySeriesLabelModule(Highcharts);

export const langConfig = {
	contextButtonTitle: 'Download export',
};

export const DEFAULT_HEIGHT = 440;

export const chartColors = [
	'#10d4b6',
	'#212244',
	'#5D8ED8',
	'#8373DB',
	'#F3B153',
	'#FF5252',
	'#8BC34A',
	'#FFD740',
	'#FF9800',
	'#CDDC39',
	'#2196F3',
	'#673AB7',
	'#4CAF50',
	'#9C27B0',
	'#795548',
	'#9E9E9E',
	'#607D8B',
	'#AFB42B',
	'#689F38',
	'#FFB300',
	'#D84315',
	'#283593',
	'#616161',
	'#0D47A1',
	'#00796B',
	'#4DB6AC',
	'#00897B',
	'#7B1FA2',
	'#C2185B',
	'#827717',
	'#9E9E9E',
	'#607D8B',
];

export const CHART_EXPORT_WATERMARK = {
	svg: 'data:image/svg+xml;base64,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',
	left: 1180,
	top: 20,
	width: 200,
	height: 50,
};

export const fontFamily =
	"'Roboto', 'system-ui', '-apple-system', 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', 'sans-serif', 'Apple Color Emoji', 'Segoe UI Emoji'";

export const exportConfig = {
	enabled: true,
	sourceWidth: 1400,
	width: 1400,
	sourceHeight: 800,
	buttons: {
		contextButton: {
			enabled: false,
		},
		exportButton: {
			y: -1,
			text: 'Download',
			style: {
				fontFamily,
			},
			theme: {
				fill: '#262955',
				stroke: '#262955',
				states: {
					hover: {
						fill: '#000000',
						stroke: '#000000',
					},
					select: {
						fill: '#000000',
						stroke: '#000000',
					},
				},
			},
			menuItems: [
				'downloadPNG',
				'downloadJPEG',
				'downloadPDF',
				'downloadSVG',
				'separator',
				'downloadCSV',
				'downloadXLS',
			],
		},
	},
	chartOptions: {
		title: {
			margin: 20,
			style: {
				color: '#5150a9',
				fontWeight: '700',
				fontSize: '20px',
				letterSpacing: '0.05em',
				fontFamily,
			},
		},
		chart: {
			events: {
				load: function () {
					this.renderer
						.image(
							CHART_EXPORT_WATERMARK.svg,
							CHART_EXPORT_WATERMARK.left,
							CHART_EXPORT_WATERMARK.top,
							CHART_EXPORT_WATERMARK.width,
							CHART_EXPORT_WATERMARK.height
						)
						.add();
				},
			} as Highcharts.ChartEventsOptions,
		},
	},
};

interface GenericChartProps {
	children?: React.ReactNode;
	invokeChartCallbackWhenCreated?: boolean; // NOTE: usefull for eg. export, when useEffect() is not called
	options: Highcharts.Options;
	onChartRendered?: (
		chart: Highcharts.Chart,
		highcharts: typeof Highcharts,
		callbackOptions: { initialRender?: boolean }
	) => void;
	setPlotWidth?: (plotWidth: number) => void;
}

const GenericChart = ({
	children,
	invokeChartCallbackWhenCreated,
	options,
	onChartRendered,
	setPlotWidth,
}: GenericChartProps) => {
	const [renderedChart, setChart] = React.useState<Highcharts.Chart | null>(null);

	const callback = React.useCallback(
		(chart: Highcharts.Chart) => {
			if (invokeChartCallbackWhenCreated) {
				// NOTE: this callback needs to be called for export to draw SVG over exported images
				onChartRendered?.(chart, Highcharts, { initialRender: true });
			}
			setChart(chart);
		},
		[setChart]
	);

	React.useEffect(() => {
		try {
			if (renderedChart) {
				setPlotWidth?.(renderedChart.plotLeft);
				renderedChart.reflow();
				onChartRendered?.(renderedChart, Highcharts, { initialRender: false });
			}
		} catch (e) {
			console.warn('Chart reflow error:', e);
		}
	}, [options, renderedChart, onChartRendered]);

	return (
		<div className='relative'>
			<HighchartsReact callback={callback} highcharts={Highcharts} options={options} />
			{children || null}
		</div>
	);
};

export default React.memo(GenericChart);
